<template>
  <div class="schema-analysis-page">
    <div v-if="!commenterName" class="name-gate">
      <div class="name-gate-card">
        <h3>TFStage schema analysis</h3>
        <p>Enter your name to continue. It will be attached to any comments you leave on the report.</p>
        <CInput
          v-model="nameInput"
          placeholder="Your name"
          maxlength="100"
          @keyup.enter.native="enter"
        />
        <div v-if="error" class="name-gate-error">{{ error }}</div>
        <CButton color="primary" block @click="enter">Continue</CButton>
      </div>
    </div>
    <div v-else class="schema-analysis-frame-wrap">
      <div class="schema-analysis-toolbar">
        <span>Viewing as <b>{{ commenterName }}</b></span>
        <button class="change-name-btn" @click="changeName">Not you? Change name</button>
      </div>
      <iframe
        class="schema-analysis-frame"
        src="/tfstage-schema-analysis.html"
        title="TFStage schema analysis"
      ></iframe>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = "tfstage_commenter_name";

export default {
  name: "SchemaAnalysis",
  data() {
    return {
      commenterName: "",
      nameInput: "",
      error: "",
    };
  },
  created() {
    try {
      this.commenterName = localStorage.getItem(STORAGE_KEY) || "";
    } catch (e) {
      this.commenterName = "";
    }
  },
  methods: {
    enter() {
      const trimmed = this.nameInput.trim();
      if (!trimmed) {
        this.error = "Name is required.";
        return;
      }
      try {
        localStorage.setItem(STORAGE_KEY, trimmed);
      } catch (e) {
        // localStorage unavailable — proceed anyway, name just won't persist
      }
      this.commenterName = trimmed;
    },
    changeName() {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        // ignore
      }
      this.commenterName = "";
      this.nameInput = "";
    },
  },
};
</script>

<style scoped>
.schema-analysis-page {
  height: 100vh;
  width: 100%;
}
.name-gate {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f5ef;
}
.name-gate-card {
  background: #fff;
  border: 1px solid #dcd8cb;
  border-radius: 12px;
  padding: 32px 36px;
  width: 100%;
  max-width: 380px;
}
.name-gate-card h3 {
  margin: 0 0 8px 0;
}
.name-gate-card p {
  color: #6b6558;
  font-size: 13.5px;
  margin: 0 0 18px 0;
}
.name-gate-error {
  color: #8c2b2b;
  font-size: 12.5px;
  margin: -8px 0 12px 0;
}
.schema-analysis-frame-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.schema-analysis-toolbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: #fff;
  border-bottom: 1px solid #dcd8cb;
  font-size: 13px;
}
.change-name-btn {
  background: none;
  border: none;
  color: #0f6e56;
  font-size: 12.5px;
  cursor: pointer;
  padding: 0;
}
.schema-analysis-frame {
  flex: 1;
  width: 100%;
  border: none;
}
</style>
</content>
